<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="修改部门数据权限"
        :close-on-press-escape="false"
        width="800px"
        append-to-body
        top="50px"
        
        :before-close="handleClose">
        <el-form ref="form" :rules="rules" :model="formItem" label-width="120px" class="pr40">
            <el-form-item label="当前权限："><p class="ellipsis" :title="user.user_data_action">{{ user.user_data_action }}</p></el-form-item>
            <el-form-item label="选择部门或成员：">
                <el-row :gutter="20">
                    <el-col :span="20">
                        <el-input
                            placeholder="输入关键字进行过滤"
                            clearable
                            v-model="filterText">
                        </el-input>
                        <div class="tree-wrap mt4">
                            <el-tree
                                ref="tree"
                                :data="departmentData"
                                :props="treeProps"
                                class="font12px"
                                :default-expanded-keys="defaultExpandedIdArr"
                                :filter-node-method="filterNode"
                                node-key="id"
                                show-checkbox
                                check-strictly
                                :default-checked-keys="formItem.group_id"
                                @check-change="treeCheckedChange"
                            >
                                <div class="custom-tree-node" slot-scope="{ node, data }">
                                    <span :class="{'text-color-bbb':node.disabled}">{{ node.label }}</span>
                                </div>
                            </el-tree>
                        </div>
                    </el-col>
                </el-row>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">保存
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/department.js';
    import utils from '@/libs/utils.js'

    export default {
        name: "MemberActionModal",
        components: {

        },
        props: {
            user: {
                required: true,
                type: Object,
            },
        },
        data() {
            return {
                submitLoading: false,
                dialogVisible: false,
                filterText:'',
                formItem: {
                    group_id: [],
                },
                rules: {
                    group_id: [
                        // {type: 'array', required: true, message: '请选择部门或成员', trigger: 'blur'}
                    ],
                },
                departmentData: [],
                normalizer(node) {
                    return {
                        id: node.id,
                        label: node.name,
                        children: node.children,
                    }
                },
                treeProps: {
                    children: 'children',
                    label: 'name',
                    disabled:'disable',
                },
                defaultExpandedIdArr:[],
            }
        },
        watch: {
            filterText(val) {
                this.$refs.tree.filter(val);
            }
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.formItem.group_id = [];
                this.resetForm();
                this.departmentData = [];
            },
            showModal() {
                this.dialogVisible = true;
                this.$nextTick(() => {
                    this.getDepartmentTree();
                })
            },
            resetForm() {
                this.submitLoading = false;
                this.$refs['form'].resetFields();
            },
            _fmtTreeData(data) {
                data.forEach((v) => {
                    // v.checked = true;
                    // this.$set(v,'checked',true);
                    let childFields = v.children||[];
                    if(v.checked){
                        if(this.formItem.group_id.find(item=>item===v.id)){
                            console.log('group_ids 中已存在:',v.id);
                        }else{
                            this.formItem.group_id.push(v.id);
                        }

                        childFields.forEach(item=>item.checked=true);
                    }
                    if (childFields.length > 0) {
                        this._fmtTreeData(childFields)
                    }
                });
                return data;
            },
            getDepartmentTree() {
                this.departmentData = [];
                API.getGroupTreeWithUser({
                    user_id: this.user.id,
                }).then(res => {
                    let resData = res.data || {};
                    if (res.code == 200) {

                        this.formItem.group_id = [];
                        this.departmentData = this._fmtTreeData(utils.deepClone([resData]));
                        // this.formItem.group_id = this._getCheckedVal(resData.children || [], []);
                        this.$nextTick(()=>{
                            this.getNodeLevel(resData.id);
                        })
                    } else {
                        this.departmentData = [];
                        console.log('getDepartmentTree error', err);
                        this.$message.error(res.info || '请求失败');
                    }
                }, (err) => {
                    console.log('getDepartmentTree error', err);
                    this.departmentData = [];
                    this.$message.error(err.info || '请求失败');
                });
            },
            getNodeLevel(id){
                let node = this.$refs.tree.getNode(id);
                if(node.level < 4) {
                    this.defaultExpandedIdArr.push(node.data.id);
                    this.$nextTick(() => {
                        if(node.data.children) {
                            node.data.children.map(item => {
                                this.getNodeLevel(item.id)
                            })
                        }
                    })
                }
            },
            filterNode(value, data) {
                if (!value) return true;
                return data.name.indexOf(value) !== -1;
            },
            _getCheckedVal(list, result) {
                list.forEach(item => {
                    if (item.checked) {
                        result.push(item.id);
                    }
                    let children = item.children || [];
                    if (children.length > 0) {
                        return this._getCheckedVal(children, result);
                    }
                });
                return result;
            },
            treeCheckedChange(node,val){
                if(val){
                    this._setChildVal(node,val);
                }else{
                    // 取消选择
                    let pid = node.pid;
                    if(!pid){
                        pid = node.id.split('-')[0];
                    }
                    let pNode = this._findModuleById(this.departmentData,pid);
                    if(pNode&&pNode.checked){
                        // this.$message.error('祖父节点已选择，该节点不能取消');
                        node.checked = true;
                        this.$refs.tree.setChecked(node,true,false);
                    }else{
                        this._setChildVal(node,val);
                    }
                }






            },
            _setChildVal(node,val){
                let dataIndex = this.formItem.group_id.findIndex(item=>item==node.id);
                if(!node.disable){
                    this.$set(node,'checked',val);
                    this.$refs.tree.setChecked(node,val,false);
                    if(val){
                        if(dataIndex==-1){
                            this.formItem.group_id.push(node.id);
                        }
                    }else{
                        if(dataIndex!=-1){
                            this.formItem.group_id.splice(dataIndex,1);
                        }
                    }
                }

                let children = node.children||[];
                if(children.length>0){
                    children.forEach(child=>{
                        this._setChildVal(child,val);
                    })
                }
            },
            _findModuleById(data,id){
                for (let item in data) {
                    if (data[item].id == id) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findModuleById(child, id);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
            handleSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        let selectGroups = this.formItem.group_id.filter(item => !item.includes('-'));
                        let selectUsers = this.formItem.group_id.filter(item => item.includes('-'));
                        let userIds = selectUsers.map(item => {
                            let idArr = item.split('-');
                            return idArr.length == 2 ? idArr[1] : idStr;
                        });
                        this.submitLoading = true;
                        API.editUserGroupDataAction({
                            id: this.user.id,
                            group_ids: [...new Set(selectGroups)].join(','),
                            user_ids: [...new Set(userIds)].join(','),
                        }).then(res => {
                            this.$message.success(res.info || '操作成功');
                            this.dialogVisible = false;
                            this.resetForm();
                            this.$emit('update');
                            this.submitLoading = false;
                        }, (err) => {
                            console.log('editUserGroupDataAction error', err);
                            this.$message.error(err.info || '操作失败');
                            this.submitLoading = false;
                        });
                    } else {
                        return false;
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .action-btn {
        width: 120px;
    }

    .tree-wrap{
        min-height: 100px;
        max-height: 50vh;
        overflow-y: scroll;
    }
    .text-color-bbb{
        color: #bbb;
    }
</style>
